var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "center-package-items" } },
    [
      _c("div", { staticClass: "flex" }, [
        _c(
          "div",
          {
            staticClass:
              "sticky left-80 z-40 h-24 px-6 flex items-center justify-between border-b border-slate-400",
            style: { width: "calc(100vw - 20rem - 0.5rem)" }
          },
          [
            _c("div", [
              _c(
                "div",
                { staticClass: "mb-2 flex items-center gap-2" },
                [
                  _c("BlTextTitle4", { attrs: { text: "Package Items" } }),
                  _vm._v(" "),
                  _c("BlBubbleCount", {
                    attrs: { count: _vm.totalCreditPackageItems || 0 }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("BlTextBody2", {
                    attrs: {
                      text:
                        "Create and manage items to categorize credits for both packages and manual transactions, ensuring consistent pricing and organization."
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex items-center gap-4" },
              [
                _c("BlInputButton", {
                  attrs: { icon: "plus", label: "Item" },
                  on: {
                    clicked: function($event) {
                      _vm.newOpened = true
                    }
                  }
                })
              ],
              1
            )
          ]
        )
      ]),
      _vm._v(" "),
      _vm.newOpened
        ? _c("NewPackageItemModal", {
            on: {
              "close-modal": function($event) {
                _vm.newOpened = false
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "flex" }, [
        _c(
          "div",
          {
            staticClass:
              "sticky left-80 z-30 py-4 px-6 flex items-center gap-2",
            style: { width: "calc(100vw - 20rem - 0.5rem)" }
          },
          [
            _c("BlInputSearch", {
              staticClass: "w-80",
              attrs: { input: _vm.searchInput },
              on: { changed: _vm.onInputSearch }
            }),
            _vm._v(" "),
            _c("BlSort", {
              staticClass: "w-60",
              attrs: {
                options: _vm.sortOptions,
                defaultValue: _vm.defaultSort
              },
              on: {
                change: function($event) {
                  return _vm.onChangeSort($event)
                }
              },
              model: {
                value: _vm.sortInput,
                callback: function($$v) {
                  _vm.sortInput = $$v
                },
                expression: "sortInput"
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.pageLoading
        ? _c("div", { staticClass: "w-full h-100 grid place-items-center" }, [
            _c("div", { staticClass: "blum-loader" })
          ])
        : !_vm.creditPackageItems.length
        ? _c(
            "div",
            { staticClass: "h-100 grid place-items-center" },
            [
              _vm.searchInput.model
                ? _c("BlTextBody2", {
                    staticClass: "text-slate-700 text-center",
                    attrs: { text: "Oops, the package item(s) not found." }
                  })
                : _c("BlTextBody2", {
                    staticClass: "text-slate-700 text-center",
                    attrs: {
                      text:
                        "Oops, there are no package item(s) available at this center."
                    }
                  })
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "mb-8" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "sticky top-18 z-20 flex items-center flex-grow bg-slate-300 rounded-t",
                  attrs: { id: "package-header" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "sticky left-80 z-10 pl-6 flex bg-slate-100"
                    },
                    [
                      _c(
                        "BlTooltip",
                        {
                          staticClass:
                            "w-60 h-12 px-4 flex items-center flex-shrink-0 bg-slate-300 border-t border-slate-400 rounded-tl border-l border-r"
                        },
                        [
                          _c("BlTextSubtitle3", {
                            staticClass: "truncate",
                            attrs: { text: "Item" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "BlTooltip",
                    {
                      staticClass:
                        "w-32 h-12 px-4 flex items-center flex-shrink-0 bg-slate-300 border-t border-slate-400"
                    },
                    [
                      _c("BlTextSubtitle3", {
                        staticClass: "truncate",
                        attrs: { text: "Status" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "BlTooltip",
                    {
                      staticClass:
                        "w-48 h-12 px-4 flex items-center flex-shrink-0 bg-slate-300 border-t border-slate-400"
                    },
                    [
                      _c("BlTextSubtitle3", {
                        staticClass: "truncate",
                        attrs: { text: "Standard retail price" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "BlTooltip",
                    {
                      staticClass:
                        "w-48 h-12 px-4 flex items-center flex-shrink-0 bg-slate-300 border-t border-slate-400"
                    },
                    [
                      _c("BlTextSubtitle3", {
                        staticClass: "truncate",
                        attrs: { text: "Provider" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "BlTooltip",
                    {
                      staticClass:
                        "w-100 h-12 px-4 flex items-center flex-shrink-0 bg-slate-300 border-t border-slate-400 flex-grow"
                    },
                    [
                      _c("BlTextSubtitle3", {
                        staticClass: "truncate",
                        attrs: { text: "Description" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "sticky right-0 z-10 pr-6 flex bg-slate-100"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "w-16 h-12 px-4 flex items-center flex-shrink-0 bg-slate-300 border-t border-slate-400 rounded-tr border-r"
                        },
                        [_c("BlTextSubtitle3", { attrs: { text: "" } })],
                        1
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm._l(_vm.creditPackageItems, function(creditPackageItem, idx) {
                return _c("PackageItemItem", {
                  key: creditPackageItem.id,
                  attrs: {
                    creditPackageItem: creditPackageItem,
                    isLast: idx + 1 === _vm.creditPackageItems.length,
                    left: "20rem"
                  },
                  on: {
                    "open-panel": function($event) {
                      return _vm.onOpenPanel(creditPackageItem.id)
                    }
                  }
                })
              })
            ],
            2
          ),
      _vm._v(" "),
      _vm.totalCreditPackageItems > 25
        ? _c(
            "div",
            { staticClass: "flex mb-36" },
            [
              _c("BlInputPagination", {
                staticClass: "sticky left-86",
                style: { width: "calc(100vw - 20rem - 3rem - 0.5rem)" },
                attrs: {
                  page: _vm.page,
                  perPage: _vm.perPage,
                  total: _vm.totalCreditPackageItems
                },
                on: {
                  changed: _vm.changePage,
                  "changed-per-page": _vm.changePerPage
                }
              })
            ],
            1
          )
        : _c("div", { staticClass: "mb-46" }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "fixed top-0 w-116 flex flex-col bg-pure-white border border-slate-400 transition-all duration-300 overflow-y-auto",
          class: [_vm.panelOpened ? "right-0" : "-right-116"],
          style: { height: "calc(100vh)", zIndex: 101 },
          attrs: { "data-id": _vm.panelId, id: "panel-details" }
        },
        [
          _vm.panelLoading
            ? _c("div", { staticClass: "h-full grid place-items-center" }, [
                _c("div", { staticClass: "blum-loader" })
              ])
            : _vm.creditPackageItem
            ? _c("PackageItemPanel", {
                attrs: {
                  "data-id": _vm.panelId,
                  panelId: _vm.panelId,
                  creditPackageItem: _vm.creditPackageItem
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-054dd3c9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-054dd3c9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/center/CenterPackageItems.vue
// module id = null
// module chunks = 